import { Err, ResponseData } from 'types';
import type { DashboardMetricsResponse } from 'types';

import { http } from '.';

export const getCompanyStatistics = async () => {
  return await http.get<Err, ResponseData<DashboardMetricsResponse>>(
    'Dashboard/GetCompanyStatistics'
  );
};
